import axios from 'axios';
import { TFilterMale, TListMaleOnlineResponse } from 'types';

const getListMaleOnline = async (body: {
  currentPage: number;
  pageSize: number;
  filter: TFilterMale;
}): Promise<TListMaleOnlineResponse> => {
  return await axios.post('male/list', body).then((response) => response.data);
};

export { getListMaleOnline };
